import axios from 'axios';
import { constructServiceURL } from '../../../../../../../utils/URLTools';

const apiFetchRouteModificationTransactionsHistory = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getRouteModificationTransactionHistory',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
      transactionId: payload.params.transactionId,
    },
  });
  return axios.get(serviceUrl);
};

export default apiFetchRouteModificationTransactionsHistory;
